import { useState, useCallback } from 'react';

import { Button } from 'antd';

export default function SaveButton({ text, onSave, disabled }) {
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(async () => {
    setLoading(true);
    try {
      await onSave();
    } finally {
      setLoading(false);
    }
  }, [onSave]);
  return (
    <Button
      type="primary"
      onClick={onClick}
      disabled={loading || disabled}
      loading={loading}
    >
      {text || '保存'}
    </Button>
  );
}
